import querystring from "query-string";

const Links = {
  HOME: "/",
  LOGIN: "/login",
  ESQUECI_SENHA: "/login/esqueci-senha",
  USUARIOS: (query) => querystring.stringifyUrl({ url: "/usuarios", query }),
  ASSOCIACOES_USUARIOS: (query) =>
    querystring.stringifyUrl({ url: "/associacoes", query }),
  UTILIZACAO_USUARIOS: (query) =>
    querystring.stringifyUrl({ url: "/utilizacao", query }),
  UTILIZACAO_CONJUNTO_DE_DADOS: (query) =>
    querystring.stringifyUrl({ url: "/utilizacao-conjunto-de-dados", query }),
  CADASTRO_USUARIO: "/usuarios/cadastro-usuario",
  CATALOGO: (collectionName = "", query) =>
    query
      ? querystring.stringifyUrl({
        url: `/catalogo-de-conjunto-de-dados-compartilhados${collectionName}`,
        query,
      })
      : `/catalogo-de-conjunto-de-dados-compartilhados${collectionName}`,
  GESTAO_DADOS: (query) =>
    querystring.stringifyUrl({ url: "/gestao-de-dados", query }),
  EDIT_CONJUNTO_DADOS: (collectionName, query) =>
    querystring.stringifyUrl({
      url: `/gestao-de-dados${collectionName}`,
      query,
    }),
  UTILIZACAO_CONJUNTO_DE_DADOS_DERIVADOS: (query) =>
    querystring.stringifyUrl({
      url: "/utilizacao-conjunto-de-dados-derivados",
      query,
    }),
  GESTAO_DADOS_DERIVADOS: (query) =>
    querystring.stringifyUrl({ url: "/gestao-de-dados-derivados", query }),
  EDIT_CONJUNTO_DADOS_DERIVADOS: (collectionName, query) =>
    querystring.stringifyUrl({
      url: `/gestao-de-dados-derivados${collectionName}`,
      query,
    }),
  PERFIL_USUARIO: (username) => `/conta/perfil${username}`,
  TOKENS_USUARIO: (username) => `/conta/tokens${username}`,
  JDBC_USUARIO: (username) => `/conta/jdbc${username}`,
  ACESSOS_USUARIO: (username, query) =>
    query
      ? querystring.stringifyUrl({ url: `/conta/acessos${username}`, query })
      : `/conta/acessos${username}`,
  PEDIDOS_USUARIO_REQUEST_COLLECTIONS: (username, query) =>
    query
      ? querystring.stringifyUrl({ url: `/conta/pedidos${username}`, query })
      : `/conta/pedidos${username}`,
  PEDIDOS_ACESSO_USUARIO: (username) => `/conta/pedidos-acesso${username}`,
  PEDIDOS_MUDANCA_USUARIO: (username) => `/conta/pedidos-mudanca${username}`,
  ESTATISTICA_CAMADA_DE_SERVICO_USUARIO: (username) =>
    `/conta/camada-de-servico${username}`,
  ACESSO_PIPELINES_USUARIO: (username, query) => query ? querystring.stringifyUrl({ url: `/conta/acesso-pipelines${username}`, query }) :
    `/conta/acesso-pipelines${username}`,
  ACESSO_PIPELINES_USUARIO_CADASTRO: (username) =>
    `/conta/acesso-pipelines/cadastro${username}`,
  ACESSO_PIPELINES_USUARIO_EDICAO: (username, pipelineAccessId) =>
    `/conta/acesso-pipelines/edicao${username}${pipelineAccessId}`,
  ESTATISTICAS: "/estatisticas-gerais",
  ESTATISTICA_CONJUNTO_DADOS: "/estatisticas-gerais/conjunto-dados",
  ESTATISTICA_ARMAZENAMENTO: "/estatisticas-gerais/armazenamento",
  ESTATISTICA_CAMADA_SERVICO: "/estatisticas-gerais/camada-servico",
  ESTATISTICA_CONJUNTO_DADOS_CASSANDRA:
    "/estatisticas-gerais/conjunto-dados/cassandra",
  ESTATISTICA_CONJUNTO_DADOS_HADOOP:
    "/estatisticas-gerais/conjunto-dados/hadoop",
  ESTATISTICA_CONJUNTO_DADOS_MONGO: "/estatisticas-gerais/conjunto-dados/mongo",
  ESTATISTICA_INGESTOR: (query) =>
    querystring.stringifyUrl(
      { url: "/estatisticas-gerais/ingestor", query },
      { arrayFormat: "bracket" }
    ),
  ESTATISTICA_CAMADA_DE_SERVICO_LISTA_USUARIO: (query) =>
    querystring.stringifyUrl({
      url: "/estatisticas-gerais/camada-de-servico/usuarios",
      query,
    }),
  ESTATISTICA_CAMADA_DE_SERVICO_LISTA_SISTEMA: (query) =>
    querystring.stringifyUrl({
      url: "/estatisticas-gerais/camada-de-servico/sistemas",
      query,
    }),
  ESTATISTICA_CAMADA_DE_SERVICO_LISTA_CONJUNTO_DE_DADOS: (query) =>
    querystring.stringifyUrl({
      url: "/estatisticas-gerais/camada-de-servico/conjuntos",
      query,
    }),
  ESTATISTICA_CAMADA_DE_SERVICO_SISTEMA: (sistemname) =>
    `/estatisticas-gerais/camada-de-servico/sistemas${sistemname}`,
  ESTATISTICA_CAMADA_DE_SERVICO_CONJUNTO_DE_DADOS: (collectionname) =>
    `/estatisticas-gerais/camada-de-servico/conjuntos${collectionname}`,
  GERIR_PEDIDOS_DE_ACESSO: (query) =>
    querystring.stringifyUrl({ url: "/gerir-pedidos-de-acesso", query }),
  GERIR_PEDIDOS_DE_MUDANCA: (query) =>
    querystring.stringifyUrl({ url: "/gerir-pedidos-de-mudanca", query }),
  GERIR_PEDIDOS_DE_SISTEMA: (query) =>
    querystring.stringifyUrl({ url: "/gerir-pedidos-de-sistema", query }),
  APP_CONFIGURACAO_GERAL: (query) =>
    querystring.stringifyUrl({ url: "/configuracao/geral", query }),
  APP_CONFIGURACAO_EXPRESSOES: (query) =>
    querystring.stringifyUrl({ url: "/configuracao/expressoes", query }),
  APP_CONFIGURACAO_EXPRESSOES_CADASTRO: "/configuracao/expressoes/cadastro",
  APP_CONFIGURACAO_EMAILS: (query) =>
    querystring.stringifyUrl({ url: "/configuracao/emails", query }),
  APP_CONFIGURACAO_EMAILS_PARAMETROS: (emailId, query) =>
    query
      ? querystring.stringifyUrl({
        url: `/configuracao/email/configuracao-template${emailId}`,
        query,
      })
      : `/configuracao/email/configuracao-template${emailId}`,
  APP_CONFIGURACAO_EXPRESSOES_EDICAO: (driver, query) =>
    query
      ? querystring.stringifyUrl({
        url: `/configuracao/expressoes/edicao${driver}`,
        query,
      })
      : `/configuracao/expressoes/edicao${driver}`,
  APP_CONFIGURACAO_DRIVERS: (query) =>
    querystring.stringifyUrl({ url: "/configuracao/drivers", query }),
  APP_CONFIGURACAO_DRIVERS_CADASTRO: "/configuracao/drivers/cadastro",
  APP_CONFIGURACAO_DRIVERS_EDICAO: (driver, query) =>
    query
      ? querystring.stringifyUrl({
        url: `/configuracao/drivers/edicao${driver}`,
        query,
      })
      : `/configuracao/drivers/edicao${driver}`,
  APP_VALIDACAO: (query) =>
    querystring.stringifyUrl({ url: "/configuracao/validacao", query }),
  APP_DOCUMENTOS_INTERNOS: (document, query) =>
    query
      ? querystring.stringifyUrl({
        url: `/configuracao/documentos-internos${document}`,
        query,
      })
      : `/configuracao/documentos-internos${document}`,
  APP_CONFIGURACAO_ACESSO_PIPELINES: (query) => querystring.stringifyUrl({ url: "/configuracao/acesso-pipelines", query }),
  APP_CONFIGURACAO_ACESSO_PIPELINES_CADASTRO: "/configuracao/acesso-pipelines/cadastro",
  APP_CONFIGURACAO_ACESSO_PIPELINES_EDICAO: (pipelineAccessId) => `/configuracao/acesso-pipelines/edicao${pipelineAccessId}`,
  INGEST_FILE: (token, query) =>
    query
      ? querystring.stringifyUrl({ url: `/ingerir-arquivo${token}`, query })
      : `/ingerir-arquivo${token}`,
  CADASTRO_ASSOCIACAO_USER_COL: (collectionName) =>
    `/gestao-de-dados${collectionName}/cadastro-associacao`,
  INSTITUICOES: (query) =>
    querystring.stringifyUrl({ url: "/instituicoes", query }),
  CADASTRO_INSTITUICAO: "/instituicoes/cadastro",
  PERFIL_INSTITUICAO: (institution) => `/instituicoes/perfil${institution}`,
  SISTEMAS: (query) => querystring.stringifyUrl({ url: "/sistemas", query }),
  CADASTRO_SISTEMA: "/sistemas/cadastro",
  ROTA_SISTEMA: (system) => `/sistemas/rota${system}`,
  PERFIL_SISTEMA: (system) => `/sistemas/perfil${system}`,
  TOKENS_SISTEMA: (system) => `/sistemas/token${system}`,
  JDBC_SISTEMA: (system) => `/sistemas/jdbc${system}`,
  FONTE_DE_ORIGEM_SISTEMA: (system) => `/sistemas/origem-dos-dados${system}`,
  DOMINIOS: (query) => querystring.stringifyUrl({ url: "/dominios", query }),
  CADASTRO_DOMINIO: "/dominios/cadastro",
  PERFIL_DOMINIO: (system) => `/dominios/perfil${system}`,
  TOKENS_DOMINIO: (system) => `/dominios/token${system}`,
  CONJUNTOS_DOMINIO: (system) => `/dominios/conjunto-de-dados${system}`,
  MONITORAMENTO_INGESTOR: "/monitoramento-ingestor",
  PIPELINE_AGENDAMENTO: (query) => querystring.stringifyUrl({ url: "/pipeline-de-dados", query }),
  EDIT_PIPELINE: (pipelineName, query) =>
    querystring.stringifyUrl({
      url: `/pipeline${pipelineName}`,
      query,
    }),
  GESTAO_DE_PIPELINE_INGESTAO: (query) =>
    querystring.stringifyUrl({ url: "/gestao-pipeline", query }),
  GESTAO_DE_PIPELINE_CONSUMO: (query) =>
    querystring.stringifyUrl({ url: "/gestao-pipeline-consumo", query }),
  PIPELINES: (query) =>
    querystring.stringifyUrl({ url: "/pipelines", query }),
};

export default Links;

export const titles = {
  "/": "Início",
  "/login": "Login",
  "/usuarios": "Usuários",
  "/associacoes": "Associações de usuários",
  "/usuarios/cadastro-usuario": "Cadastro de usuário",
  "/catalogo-de-conjunto-de-dados-compartilhados": "Catálogo",
  "/gestao-de-dados": "Gestão de dados",
  "/gestao-de-dados/edicao": "Edição do conjunto de dados",
  "/gestao-de-dados/cadastro-associacao":
    "Cadastro de associação do conjunto de dados",
  "/conta/perfil": "Perfil de usuário",
  "/conta/tokens": "Tokens de usuário",
  "/conta/jdbc": "JDBC de usuário",
  "/conta/acessos": "Acessos de usuário",
  "/conta/pedidos": "Pedidos de usuário",
  "/conta/acesso-pipelines": "Acesso pipelines",
  "/conta/acesso-pipelines/cadastro": "Novo acesso de pipeline",
  "/conta/acesso-pipelines/edicao": "Edição acesso de pipeline",
  "/estatisticas-gerais": "Estatísticas gerais",
  "/estatisticas-gerais/armazenamento": "Estatísticas gerais - Armazenamento",
  "/estatisticas-gerais/camada-servico": "Estatísticas gerais - Camada Serviço",
  "/estatisticas-gerais/conjunto-dados": "Estatísticas de conjunto de dados",
  "/estatisticas-gerais/conjunto-dados/cassandra":
    "Estatísticas de conjunto de dados - Cassandra",
  "/estatisticas-gerais/conjunto-dados/hadoop":
    "Estatísticas de conjunto de dados - Hadoop",
  "/estatisticas-gerais/conjunto-dados/mongo":
    "Estatísticas de conjunto de dados - Mongo",
  "/estatisticas-gerais/ingestor": "Estatísticas do Ingestor",
  "/estatisticas-gerais/camada-de-servico": "Estatísticas da camada de serviço",
  "/gerir-pedidos-de-acesso": "Gestão de pedidos de acesso",
  "/gerir-pedidos-de-mudanca": "Gestão de pedidos de mudança",
  "/gerir-pedidos-de-sistema": "Gestão de pedidos de sistema",
  "/configuracao/geral": "Configuração geral",
  "/configuracao/drivers": "Configuração de drivers",
  "/configuracao/drivers/cadastro": "Cadastro de driver",
  "/configuracao/drivers/edicao": "Edição de driver",
  "/configuracao/validacao": "Validação de Usuários",
  "/configuracao/documentos-internos": "Documentos Internos",
  "/ingerir-arquivo": "Upload",
  "/instituicoes": "Instituições",
  "/instituicoes/cadastro": "Cadastro de instituição",
  "/instituicoes/perfil": "Perfil de instituição",
  "/sistemas": "Sistemas",
  "/sistemas/cadastro": "Cadastro de sistema",
  "/sistemas/perfil": "Perfil de sistema",
  "/sistemas/token": "Token de sistema",
  "/sistemas/origem-dos-dados": "Origem dos dados do sistema",
  "/dominios": "Domínio",
  "/dominios/cadastro": "Cadastro de domínio",
  "/dominios/perfil": "Perfil de domínio",
  "/dominios/token": "Token de domínio",
  "/dominios/conjunto-de-dados": "Conjunto de dados de domínio",
  "/monitoramento-ingestor": "Monitoramento do Ingestor",
  "/pipeline": "Pipeline de dados",
  "/gestao-pipeline": "Gerenciamento de Pipelines",
};

export const hashes = {
  politicasPrivacidade: "#PoliticasDePrivacidade",
  termosUso: "#TermosDeUso",
};
